module.exports = (__webpack_require__(2))(83);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/HierarchyWidget.js from dll-reference girder_plugin_slicer_cli_web
// module id = 173
// module chunks = 0